<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Enter OTP</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            {{ message }}
          </p>
        </v-card-text>

        <ValidationObserver ref="observer">
          <v-form @submit.prevent="otpEntered">
            <v-card-text class="crud-card-text">
              <ValidationProvider
                id="otp"
                v-slot="{ errors }"
                name="otp"
                rules="required"
              >
                <v-text-field
                  id="otp"
                  v-model="otp"
                  :error-messages="errors"
                  label="OTP*"
                />
              </ValidationProvider>
            </v-card-text>
            <v-card-actions class="crud-card-actions">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-btn
                    rounded
                    depressed
                    :loading="buttonLoading"
                    color="primary"
                    class="left-edit-btn"
                    type="submit"
                  >
                    <span>Yes, login as testator</span>
                    <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
                  </v-btn>

                  <v-btn
                    class="right-edit-btn"
                    rounded
                    depressed
                    outlined
                    color="grey.darken1"
                    @click="closeDialog()"
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'LoginAsTestatorOTP',
    props: {
      testator: {
        required: true,
        type: Object,
      },
      showDialog: {
        required: true,
        type: Boolean,
      },
      message: {
        required: false,
        type: String,
      },
    },
    data(props) {
      return {
        dialog: props.showDialog,
        buttonLoading: false,
        otp: '',
      };
    },
    computed: {
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
    },
    watch: {
      showDialog(newValue, oldValue) {
        this.dialog = newValue;
      },
    },
    methods: {
      otpEntered() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.$emit('otpSubmitted', {
              testator: this.testator,
              otp: this.otp,
            });
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
